export class ContractorJobStatus {
  static readonly NotSet = 0;
  static readonly  New = 1;
  static readonly  InProgress = 2;
  static readonly  Completed = 3;
  static readonly  UnableToComplete = 4;
  static readonly  Cancelled = 5;

  static toDisplayName(value: ContractorJobStatus): string {
    switch (value) {
      case ContractorJobStatus.NotSet:
        return 'Not Set';
      case ContractorJobStatus.New:
        return 'New';
      case ContractorJobStatus.InProgress:
        return 'In Progress';
      case ContractorJobStatus.Completed:
        return 'Completed';
      case ContractorJobStatus.UnableToComplete:
        return 'Unable To Complete';
      case ContractorJobStatus.Cancelled:
        return 'Cancelled';
      default:
        return 'Unknown';
    }
  }
}
